<!-- Information Modal -->
<div class="modal-header">
    <h5 class="modal-title">Information</h5>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{ message }}
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-secondary"
        (click)="activeModal.dismiss('Cross click')"
    >
        OK
    </button>
</div>
